export default "__VITE_ASSET__CtPBTMOP__"